/* Alinga | 30-10-2026
   Highgrove sticky add to cart helpers (markup in sections/product-information.liquid).
   1. Rotates the trust strip messages every 3.2s with a 300ms fade.
   2. Mirrors the reviews.io rating snippet from the product details into the bar.
      The rating only shows when the product has 1 or more reviews.
   3. Rating click scrolls to the reviews.io widget.
   Everything is looked up on each run, so it keeps working after the bar is
   morphed on a variant change. */
(function () {
  'use strict';

  if (window.__hgStickyAtc) return;
  window.__hgStickyAtc = true;

  var ROTATE_MS = 3200;

  function rotate() {
    if (document.hidden) return;
    document.querySelectorAll('[data-hg-strip]').forEach(function (strip) {
      if (strip.matches(':hover, :focus-within')) return;
      var items = strip.querySelectorAll('.hg-satc__msg');
      if (items.length < 2) return;
      var current = 0;
      items.forEach(function (el, i) {
        if (el.classList.contains('is-active')) current = i;
      });
      items[current].classList.remove('is-active');
      items[(current + 1) % items.length].classList.add('is-active');
    });
  }

  function readRating() {
    var snippets = document.querySelectorAll('.ruk_rating_snippet');
    for (var i = 0; i < snippets.length; i++) {
      var s = snippets[i];
      if (s.closest('.hg-satc, product-card, .product-card, .card-gallery')) continue;
      var countEl = s.querySelector('.ruk-rating-snippet-count');
      if (!countEl) continue;
      var match = (countEl.textContent || '').match(/(\d[\d,]*)/);
      if (!match) continue;
      var count = parseInt(match[1].replace(/,/g, ''), 10) || 0;
      var avgEl = s.querySelector('b');
      var avg = avgEl ? parseFloat(avgEl.textContent) : NaN;
      if (isNaN(avg)) {
        // Fall back to counting full star icons
        avg = s.querySelectorAll('[class*="percentage-star--100"]').length;
      }
      return { count: count, avg: avg };
    }
    return null;
  }

  function syncRating() {
    var data = readRating();
    document.querySelectorAll('[data-hg-rating]').forEach(function (link) {
      if (!data || data.count < 1 || !(data.avg > 0)) {
        if (!link.hidden) link.hidden = true;
        return;
      }
      var avgText = data.avg.toFixed(1);
      var countText = '(' + data.count + (data.count === 1 ? ' review)' : ' reviews)');
      var avgNode = link.querySelector('[data-hg-rating-avg]');
      var countNode = link.querySelector('[data-hg-rating-count]');
      var fill = link.querySelector('[data-hg-rating-fill]');
      if (avgNode && avgNode.textContent !== avgText) avgNode.textContent = avgText;
      if (countNode && countNode.textContent !== countText) countNode.textContent = countText;
      if (fill) fill.style.setProperty('--hg-rating-pct', Math.min(100, (data.avg / 5) * 100) + '%');
      link.setAttribute('aria-label', avgText + ' out of 5 stars, ' + data.count + (data.count === 1 ? ' review' : ' reviews'));
      if (link.hidden) link.hidden = false;
    });
  }

  function setBarHeight() {
    var bar = document.querySelector('.hg-satc__bar');
    if (!bar) return;
    var h = bar.getBoundingClientRect().height;
    if (h) document.documentElement.style.setProperty('--hg-satc-total', Math.round(h) + 'px');
  }

  document.addEventListener('click', function (event) {
    var link = event.target.closest('[data-hg-rating]');
    if (!link) return;
    var target = document.querySelector(link.getAttribute('data-reviews-target') || '');
    if (!target) return;
    event.preventDefault();
    target.scrollIntoView({
      behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
      block: 'start',
    });
  });

  var scheduled = false;
  function schedule() {
    if (scheduled) return;
    scheduled = true;
    setTimeout(function () {
      scheduled = false;
      syncRating();
      setBarHeight();
    }, 60);
  }

  function init() {
    if (!document.querySelector('.hg-satc')) return;
    schedule();
    setInterval(rotate, ROTATE_MS);

    // reviews.io fills its snippet asynchronously and the bar is morphed on variant change.
    var root = document.querySelector('main') || document.body;
    new MutationObserver(schedule).observe(root, { childList: true, subtree: true, characterData: true });
    window.addEventListener('resize', schedule, { passive: true });
    window.addEventListener('load', schedule);
    document.addEventListener('visibilitychange', schedule);
    setTimeout(schedule, 1500);
    setTimeout(schedule, 4000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
